import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

const routing = [
    // @Page 메인페이지
    {
        path: '/',
        name: 'Main',
        component: () =>
            import ('../views/main/NaviBar.vue'),
        meta: { requiresAuth: true },
        children: [
            // @NoPrintPage 대시보드
            {
                path: 'dashboard',
                name: 'MainDashboard',
                component: () =>
                    import ('../views/main/Index.vue'),
                meta: { requiresAuth: true }
            }
        ]
    },
    // @Page 프린트 : 단면으로 정해진 페이지 중심
    {
        path: '/print',
        name: 'MainPrint',
        component: () =>
            import ('../views/print/Index.vue'),
        meta: { requiresAuth: true },
        children: [
            // @Print
            {
                path: 'trigger',
                name: 'PrintTriggerContainer',
                component: () =>
                    import ('../views/print/Index.vue'),
                meta: { requiresAuth: true }, 
            },
        ],
    },
    // // @page 프린트 : 근로계약 관련 정보 @903번줄 중복으로 해당 라우터 경로 삭제, 이상이 없다면 25.06월 이후 삭제
    // {
    //     path: '/print/employees',
    //     name: 'EmployeeContract',
    //     component: () => 
    //         import ('../views/print/EmployeeContract.vue'),
    //     meta: { requiresAuth: true },
    // },
    // @Page 프린트 : 정해지지 않은 단면
    {
        path: '/prints',
        name: 'PrintsTrigger',
        component: () =>
            import ('../views/print/IndexMarginPrint.vue'),
        meta: { requiresAuth: true },
    },
    // @Page 프린트 : 결재문서
    {
        path: '/print/approval',
        name: 'PrintApprovalTrigger',
        component: () =>
            import ('../views/print/IndexApprovalPrint.vue'),
        meta: { requiresAuth: true },
    },
    // @Page 프린트 : 재무회계
    {
        path: '/print/financial',
        name: 'PrintFinancialTrigger',
        component: () =>
            import ('../views/print/IndexFinancialPrint.vue'),
        meta: { requiresAuth: true },
    },
    // @Page 프린트 : 재무회계 / 월별손익분석
    {
        path: '/print/monthly-profit-loss-analysis',
        name: 'PrintMonthlyProfitLossAnalysis',
        component: () =>
            import ('../views/financial/status/MonthlyProNossAna.vue'),
        meta: { requiresAuth: true },
    },
    // @Page 프린트 : 재무회계 / 상대계정 분석표
    {
        path: '/print/correspond-funding-analysis',
        name: 'PrintCorrespondFundingAnalysis',
        component: () =>
            import ('../views/financial/status/CorresFundAna.vue'),
        meta: { requiresAuth: true },
    },
    // @Page 공통설정
    {
        path: '/branch',
        name: 'Branch',
        component: () =>
            import ('../views/main/NaviBar.vue'),
        meta: { requiresAuth: true },
        children: [
            // @PrintPage
            {
                path: 'bath/disinfection/print',
                name: 'BathDisinfection',
                component: () =>
                    import ('../views/print/works/BathDisinfection.vue'),
                meta: { requiresAuth: true }
            },
            // @NotPrintPage
            {
                path: 'dashboard',
                name: 'BranchDashboard',
                component: () =>
                    import ('../views/branch.setting/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'account',
                name: 'BankAccountManagement',
                component: () =>
                    import ('../views/authorization/branches/BankAccountManagement.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'permission',
                name: 'BranchPermission',
                component: () =>
                    import ('../views/branch.setting/BranchPermission.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'auth',
                name: 'PermissionManage',
                component: () =>
                    import ('../views/branch.setting/BranchEmployeePermission.vue'),
                meta: { requiresAuth: true }
            },
            { // @brief : 급여정책 설정
                path: 'payslip',
                name: 'TimePayslipList',
                component: () =>
                    import('../views/branch.setting/TimePayslipList.vue'),
                    //import ('../views/branch.setting/Payslip.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'rules/recipient',
                name: 'RulesRecipient',
                component: () =>
                    import ('../views/branch.setting/RulesRecipient.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'rules/employment',
                name: 'RulesEmployment',
                component: () =>
                    import ('../views/branch.setting/RulesEmployment.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'holiday/rule',
                name: 'HolidayRuleManagement',
                component: () =>
                    import ('../views/branch.setting/ApprovalRuleMgmt.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'holiday/type',
                name: 'HolidayTypeManagement',
                component: () =>
                    import ('../views/branch.setting/HolidayTypeMgmt.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'holiday/fmevent',
                name: 'FamilyEventManagement',
                component: () =>
                    import ('../views/branch.setting/FamilyEventMgmt.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'holiday/public',
                name: 'PublicHolidayManagement',
                component: () =>
                    import ('../views/branch.setting/PublicHolidayMgmt.vue'),
                meta: { requiresAuth: true },
            },
            //  setting
            {
                path: 'setting/ocommittee',
                name: 'OperatingCommitteeManagement',
                component: () =>
                    import ('../views/branch.setting/OperatingCommitteeMgmt.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'setting/fourinsurance',
                name: 'FourInsurancesPercentManagement',
                component: () =>
                    import ('../views/branch.setting/FourInsurancesPercentMgmt.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'setting/charge/item',
                name: 'ServiceChargeItemManagement',
                component: () =>
                    import ('../views/branch.setting/ServiceChargeItemMgmt.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'setting/charge/time',
                name: 'ServiceChargeTimeManagement',
                component: () =>
                    import ('../views/branch.setting/ServiceChargeTimeMgmt.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'setting/charge/others',
                name: 'ServiceChargeOthersManagement',
                component: () =>
                    import ('../views/branch.setting/ServiceChargeOthersMgmt.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'setting/certificate',
                name: 'SettingCertificate',
                component: () =>
                    import ('../views/branch.setting/SettingCertificate.vue'),
                meta: { requiresAuth: true }
            },
        ]
    },
    /** 
     * @brief 새 창으로 메뉴 없는 화면을 구성을 하기 위해 별도 작성
     * @route routing.href _blank
     * @page sub explain
    */
    { // @brief : 단시간 근로자 시급 설정
        path: '/branch/payslip/detail',
        name: 'TimePayslipDetail',
        component: () =>
            import('../views/branch.setting/TimePayslipDetail.vue'),
        meta: { requiresAuth: true}
    },
    { // @brief : 단시간 근로자 정책 설정
        path: '/branch/payslip/policy',
        name: 'TimePayslipPolicy',
        component: () =>
            import('../views/branch.setting/TimePayslipPolicy.vue'),
        meta: { requiresAuth: true}
    },
    { // @brief : 급여정책 설정
        path: '/branch/payslip/new',
        name: 'TimePayslipNew',
        component: () =>
            import('../views/branch.setting/TimePayslipNew.vue'),
        meta: { requiresAuth: true}
    },
    // @Page 시니어페이지(고객)
    {
        path: '/senior',
        name: 'Senior',
        component: () =>
            import ('../views/main/NaviBar.vue'),
        meta: { requiresAuth: true },
        children: [
            // @PrintPage
            {
                path: 'apply/ltc',
                name: 'ApplyLongtermCareGrade',
                component: () =>
                    import ('../views/print/customer/ApplyLongtermGrade.vue'),
                meta: { requiresAuth: true }
            },
            // @NotPrintPage
            {
                path: 'dashboard',
                name: 'SeniorDashboard',
                component: () =>
                    import ('../views/senior/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status/seniors',
                name: 'StatusRegistCustom',
                component: () =>
                    import ('../views/senior/StatusSeniors.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status/regist',
                name: 'StatusRegistBoard',
                component: () =>
                    import ('../views/senior/StatusRegistBoard.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status/progress',
                name: 'StatusLevelProgress',
                component: () =>
                    import ('../views/senior/StatusLevelProgress.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'seniorInfo',
                name: 'SeniorInfo',
                component: () =>
                    import ('../views/senior/SeniorInfo.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'form',
                name: 'SeniorForm',
                component: () =>
                    import ('../views/senior/SeniorForm.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'regist/date',
                name: 'SeniorRegistDate',
                component: () =>
                    import ('../views/senior/SeniorRegistDate.vue'),
                meta: { requiresAuth: true }
            },
        ]
    },
    // @Page 수급자페이지
    {
        path: '/recipient',
        name: 'Recipient',
        component: () =>
            import ('../views/main/NaviBar.vue'),
        meta: { requiresAuth: true },
        children: [
            // @PrintPage

            // @NotPrintPage
            {
                path: 'dashboard',
                name: 'RecipientDashboard',
                component: () =>
                    import ('../views/recipient/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status/receive',
                name: 'RecipientStatus',
                component: () =>
                    import ('../views/recipient/RecipientStatus.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status/work',
                name: 'RecipientWorkStatus',
                component: () =>
                    import ('../views/recipient/RecipientWorkStatus.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status/payments',
                name: 'RecipientPaymentsStatus',
                component: () =>
                    import ('../views/recipient/RecipientPaymentsStatus.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status/level',
                name: 'RecipientLevelStatus',
                component: () =>
                    import ('../views/recipient/RecipientLevelStatus.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status/support',
                name: 'RecipientSupportStatus',
                component: () =>
                    import ('../views/recipient/RecipientSupportStatus.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'recipientInfo',
                name: 'RecipientInfo',
                component: () =>
                    import ('../views/recipient/RecipientInfo.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'edit',
                name: 'EditRecipientForm',
                component: () =>
                    import ('../views/recipient/RecipientForm.vue'),
                meta: { requiresAuth: true }
            },
            // {
            //     path: 'provisionalContract',
            //     name: 'ProvisionalContract',
            //     component: () =>
            //         import ('../views/recipient/contract/ProvisionalContract.vue'),
            //     meta: { requiresAuth: true }
            // },
            {
                path: 'provisionalContract/done',
                name: 'ProvisionalContractDone',
                component: () =>
                    import ('../views/recipient/contract/ProvisionalContractDone.vue'),
                meta: { requiresAuth: true }
            },
            { // write a new contracts
                path: 'contract',
                name: 'Contract',
                component: () =>
                    import ('../views/recipient/contract/Contract.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'contract/done',
                name: 'ContractDone',
                component: () =>
                    import ('../views/recipient/contract/ContractDone.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'receive/contract',
                name: 'ReceiveContract',
                component: () =>
                    import ('../views/recipient/contract/ReceiveContract.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'rfid/card',
                name: 'RecipientRFIDCard',
                component: () =>
                    import ('../views/recipient/work/RecipientRFID.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'rfid/day',
                name: 'RecipientDayRFID',
                component: () =>
                    import ('../views/recipient/work/RecipientDayRFID.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'rfid/list',
                name: 'PlanRFIDTagLists',
                component: () =>
                    import ('../views/recipient/work/RFIDListIndex.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'rfid/error/recipient',
                name: 'RecipientErrorRFIDList',
                component: () =>
                    import ('../views/recipient/work/RecipientErrorRFID.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'rfid/error/staff',
                name: 'StaffErrorRFIDList',
                component: () =>
                    import ('../views/recipient/work/StaffErrorRFID.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'copays/list',
                name: 'CopayDetailList',
                component: () =>
                    import ('../views/recipient/work/CopaysIndex.vue'),    
                meta: { requiresAuth: true }
            },
            {
                path: 'copays/card',
                name: 'CopayDetailCard',
                component: () =>
                    import ('../views/recipient/work/CopaysCard.vue'),
                meta: { requiresAuth: true }
            },
            // {
            //     path: 'copays/deposit/all',
            //     name: 'AllDeposit',
            //     component: () =>
            //         import ('../views/recipient/work/RecipientDepositList.vue'),
            //     meta: { requiresAuth: true }
            // },
            { // get list assessments
                path: 'assessments',
                name: 'BasicsAssessment',
                component: () =>
                    import ('../views/recipient/assessment/Index.vue'),
                meta: { requiresAuth: true }
            },
            { // get list service provider plan
                path: 'spplans',
                name: 'ServiceProvidePlans',
                component: () =>
                    import ('../views/recipient/serviceprovideplan/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'write/cist',
                name: 'BasicsAssessmentCISTWriting',
                component: () =>
                    import ('../views/recipient/assessment/CIST.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'write/fallrisk',
                name: 'BasicsAssessmentFallRiskWriting',
                component: () =>
                    import ('../views/recipient/assessment/FALLRISK.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'write/bedsore',
                name: 'BasicsAssessmentBedsoreWriting',
                component: () =>
                    import ('../views/recipient/assessment/BEDSORE.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'write/needs',
                name: 'BasicsAssessmentNeedWriting',
                component: () =>
                    import ('../views/recipient/assessment/NEEDASSESSMENT.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'write/plans',
                name: 'BasicsAssessmentPlanWriting',
                component: () =>
                    import ('../views/recipient/assessment/SERVICEPROVIDERPLAN.vue'),
                meta: { requiresAuth: true }
            },
            { // get list contracts 
                path: 'contracts',
                name: 'ReceiveContractList',
                component: () =>
                    // import ('../views/recipient/contract/Index.vue'),
                    import ('../views/recipient/contract/IndexV2.vue'),
                meta: { requiresAuth: true }
            },
            { // get list copays 
                path: 'copays',
                name: 'CopayList',
                component: () =>
                    import ('../views/recipient/work/CopaysIndex.vue'),
                meta: { requiresAuth: true }
            },
            { // get list personal ltc utilization plans
                path: 'ltcplans/utilization',
                name: 'PersonalLtcUtilizationPlans',
                component: () =>
                    import ('../views/recipient/utilization/Index.vue'),
                meta: { requiresAuth: true }
            },
            { // get list change ltc utilization plans
                path: 'ltcplans/change',
                name: 'ChangeLtcUtilizationPlans',
                component: () =>
                    import ('../views/recipient/utilization/ChangePlanIndex.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'ltcplans/change/new',
                name: 'WriteUsingChangePlans',
                component: () =>
                    import ('../views/recipient/utilization/WriteUsingChangePlan.vue'),
                meta: { requiresAuth: true }
            },
            // { // 화면 이동 → 새창으로 변경하기 위해 주석
            //     path: 'docs/necessary',
            //     name: 'NecessaryDocsList',
            //     component: () =>
            //         import ('../views/recipient/workbooks/NecessaryDocsList.vue'),
            //     meta: { requiresAuth: true }
            // },
            { // get list work of rules
                path: 'performances',
                name: 'PerformanceLogs',
                component: () =>
                    import ('../views/recipient/performance/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                // list of counsel logs
                path: 'counsels',
                name: 'CounselLogs',
                component: () =>
                    import ('../views/recipient/work/CounselLogIndex.vue'),
                meta: { requiresAuth: true }
            },
            { // change to 상태변화기록지 calendar
                path: 'daily',
                name: 'DailyWorkCalendar',
                component: () =>
                    import ('../views/recipient/work/DailyWorkCalendar.vue'),
                meta: { requiresAuth: true }
            },
            { // change to 급여제공일정 calendar
                path: 'provide/plan',
                name: 'ProvidePlanCalendar',
                component: () =>
                    import ('../views/recipient/work/ProvidePlanCalendar.vue'),
                meta: { requiresAuth: true }
            },
            {
                // a list of provide service is changed by provider
                path: 'spcr/logs',
                name: 'PlanChangeReasonLogs',
                component: () =>
                    import ('../views/recipient/work/PlanChangeReasonLogs.vue'),
                meta: { requiresAuth: true }
            },
            {
                // write a provide service is changed by provider
                path: 'spcr/write',
                name: 'WriteReasonChangePlan',
                component: () =>
                    import ('../views/recipient/work/WriteReasonChangePlan.vue'),
                meta: { requiresAuth: true }
            },
            {
                // a list of provide service is changed by provider
                path: 'eorl/logs',
                name: 'EmergencyOccurRecordLogs',
                component: () =>
                    import ('../views/recipient/work/EmergencyOccurRecordLogs.vue'),
                meta: { requiresAuth: true }
            },
            {
                // write a provide service is changed by provider
                path: 'eorl/write',
                name: 'WriteEmergencyRecord',
                component: () =>
                    import ('../views/recipient/work/WriteEmergencyRecord.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'counsel/log',
                name: 'WriteCounselLog',
                component: () =>
                    import ('../views/recipient/work/WriteCounselLog.vue'),
                meta: { requiresAuth: true }
            },
            {
                // list of conditions logs
                path: 'conditions',
                name: 'ConditionLogs',
                component: () =>
                    import ('../views/recipient/work/ConditionLogsIndex.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'emergency',
                name: 'Emergency',
                component: () =>
                    import ('../views/recipient/work/EmergencyIndex.vue'),
                meta: { requiresAuth: true }
            },
            // {
            //     path: 'emergency/write',
            //     name: 'WriteEmergency',
            //     component: () =>
            //         import ('../views/recipient/work/WriteEmergency.vue'),
            //     meta: { requiresAuth: true }
            // },
            {
                // write a conditions log
                path: 'conditions/write',
                name: 'WriteConditionLog',
                component: () =>
                    import ('../views/recipient/work/WriteConditionLog.vue'),
                meta: { requiresAuth: true }
            },
            // {
            //     path: 'conditions/log',
            //     name: 'WriteConditionLog',
            //     component: () => import('../views/recipient/work/form/ConditionForm.vue'),
            //     meta: { requiresAuth: true }
            // },
            {
                path: 'performance/form',
                name: 'PerformanceForm',
                component: () =>
                    import ('../views/print/works/RecipientPerformance.vue'),
                meta: { requiresAuth: true }
            },
            {
                // list of allowance logs
                path: 'performance',
                name: 'PerformanceIndex',
                component: () =>
                    import ('../views/recipient/work/PerformanceIndex.vue'),
                meta: { requiresAuth: true }
            },
            // @Description (25.07.01 이후)업무수행일지 연간(매트릭스) 보기 — 좌측 RecipientList 연동
            {
                path: 'casenotes/yearly',
                name: 'WorkingLogCaseNotesYearly',
                component: () =>
                    import ('../views/recipient/workbooks/WorkingLogCaseNotesYearly.vue'),
                meta: { requiresAuth: true },
            },
            {
                // list of allowance logs
                path: 'performance/cog',
                name: 'PerformanceIndexCog',
                component: () =>
                    import ('../views/recipient/work/PerformanceIndexCog.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'service/index',
                name: 'ServiceIndex',
                component: () =>
                    import ('../views/recipient/work/ServiceIndex.vue'),
                meta: { requiresAuth: true }
            },
            {
                // list of allowance logs
                path: 'disinfection',
                name: 'DisinfectionIndex',
                component: () =>
                    import ('../views/recipient/work/DisinfectionIndex.vue'),
                meta: { requiresAuth: true }
            },
            {
                // list of allowance logs
                path: 'allowances',
                name: 'AllowanceLogs',
                component: () =>
                    import ('../views/recipient/work/AllowanceLogsIndex.vue'),
                meta: { requiresAuth: true }
            },
            {
                //급여제공기록대장
                path: 'service/log/mgmt',
                name: 'ServiceLogMgmt',
                component: () =>
                    import ('../views/recipient/work/ServiceLogMgmt.vue'),
                meta: { requiresAuth: true }
            },
            {
                //일정 불일치 기록지 관리
                path: 'service/match',
                name: 'NotMatch',
                component: () =>
                    import ('../views/recipient/work/NotMatch.vue'),
                meta: { requiresAuth: true }
            },
            {
                // write a allowance log
                path: 'allowances/write',
                name: 'WriteAllowanceLog',
                component: () =>
                    import ('../views/recipient/work/WriteAllowanceLog.vue'),
                meta: { requiresAuth: true }
            },
            // {
            //     path: 'allowance/log',
            //     name: 'WriteAllowanceLog',
            //     component: () => import('../views/recipient/work/form/AllowanceForm.vue'),
            //     meta: { requiresAuth: true }
            // },
            {
                // change to 방문목욕 소독일지
                path: 'disinfectants',
                name: 'DisinfectantLogs',
                component: () =>
                    import ('../views/recipient/work/DisinfectantLogsIndex.vue'),
                meta: { requiresAuth: true }
            },
            {
                // write a disinfectant log - no needs now
                path: 'disinfectants/write',
                name: 'WriteDisinfectantLog',
                component: () =>
                    import ('../views/recipient/work/WriteDisinfectantLog.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'edit/personal',
                name: 'EditPersonalCharge',
                component: () =>
                    import ('../views/recipient/EditPersonalCharge.vue'),
                meta: { requiresAuth: true }
            },
            // {
            //     //수급계약 프린트
            //     path: 'contract/preview',
            //     name: 'ReceiverContract',
            //     component: () => import('../views/recipient/contract/ContractInfo.vue')
            // },
            // {
            //     //갱신계약 프린트
            //     path: 'contract/preview/rate',
            //     name: 'RenewRateContract',
            //     component: () => import('../views/recipient/contract/RenewRateContractInfo.vue')
            // },
            // @PrintPage
            // {
            //     //등급 갱신(변경)신청서
            //     path: 'apply/ltc',
            //     name: 'RecipientApplyLongtermCareGrade',
            //     component: () => import('../views/print/Index.vue'),
            //     meta: { requiresAuth: true }
            // },
            {
                //등급 갱신(변경)신청서
                path: 'apply/ltc',
                name: 'RecipientApplyLongtermCareGrade',
                component: () =>
                    import ('../views/print/recipient/ApplyIndex.vue'),
                meta: { requiresAuth: true }
            },
            {
                //우편발송 프린트
                path: 'address/print',
                name: 'RecipientZipcode',
                component: () =>
                    import ('../views/print/recipient/RecipientZipcode.vue'),
                meta: { requiresAuth: true }
            },
            {
                //입소이용신청서
                path: 'application/support',
                name: 'RecipientApplication',
                component: () =>
                    import ('../views/print/recipient/RecipientApplication.vue'),
                meta: { requiresAuth: true }
            },
            {
                //수가안내문
                path: 'price/notice',
                name: 'PriceChangeNotice',
                component: () =>
                    import ('../views/print/recipient/PriceChangeNotice.vue'),
                meta: { requiresAuth: true }
            },
            {
                //급여제공일정표
                path: 'service/plan/print',
                name: 'ServicePlan',
                component: () =>
                    import ('../views/print/recipient/ServicePlan.vue'),
                meta: { requiresAuth: true }
            },
            //binder
            {
                path: 'bind/workbook',
                name: 'BindRecipientWorkBook',
                component: () =>
                    import ('../views/recipient/workbooks/BindRecipients.vue'),
                meta: { requiresAuth: true },
            },
            {
                path: 'bind/custombook',
                name: 'BindRecipientCustomBook',
                component: () =>
                    import ('../views/recipient/workbooks/BindCustoms.vue'),
                meta: { requiresAuth: true },
            },
            // 욕조소독일지
            {
                path: 'disinfection/preview',
                name: 'RecipientDisinfection',
                component: () =>
                    import ('../views/print/works/RecipientDisinfection.vue'),
                meta: { requiresAuth: true },
            },
            // 상태기록지
            {
                path: 'condition/preview',
                name: 'ConditionLog',
                component: () =>
                    import ('../views/print/works/ConditionLog.vue'),
                meta: { requiresAuth: true },
            },
            // 급여제공기록지 - 요양
            {
                path: 'provide/preview/care',
                name: 'ProvideCare',
                component: () =>
                    import ('../views/print/works/ProvideRecord_Care.vue'),
                meta: { requiresAuth: true },
            },
            // 급여제공기록지 - 목욕
            {
                path: 'provide/preview/bath',
                name: 'ProvideBath',
                component: () =>
                    import ('../views/print/works/ProvideRecord_Bath.vue'),
                meta: { requiresAuth: true },
            },
            //우편물발송대장
            {
                path: 'post/mgmt',
                name: 'SendPostMgmt',
                component: () =>
                    import ('../views/print/recipient/SendPostMgmt.vue'),
                meta: { requiresAuth: true },
            },
            // New WorkingLogCaseNotes (new performance logs)
            {
                path: 'casenotes',
                name: 'WorkingLogCaseNotes',
                component: () =>
                    import ('../views/recipient/workbooks/WorkingLogCaseNotes.vue'),
                meta: { requiresAuth: true },
            }
        ]
    },
    // 업무수행일지(NEW) - 새창 열기
    {
        path: '/logs/casenotes',
        name: 'WorkingLogCaseNotesPopup',
        component: () =>
            import ('../views/recipient/workbooks/WorkingLogCaseNotes.vue'),
        meta: { requiresAuth: true },
    },
    // @Description 급여제공기록지
    {
        //일정 불일치 기록지 관리
        path: '/report/service/match',
        name: 'NotMatchBlank',
        component: () =>
            import ('../views/recipient/work/NotMatch.vue'),
        meta: { requiresAuth: true }
    },
    // @Description (25.07.01 이후)업무수행일지 작성하기
    {
        path: '/logs/casenotes/edit',
        name: 'WorkingLogCaseNoteEdit',
        component: () =>
            import ('../views/recipient/workbooks/WorkingLogCaseNoteEdit.vue'),
        meta: { requiresAuth: true },
    },
    // @Description (25.07.01 이후)업무수행일지 전체목록 보기 (새창)
    {
        path: '/logs/casenotes/all',
        name: 'WorkingLogCaseNotesAll',
        component: () =>
            import ('../views/recipient/workbooks/WorkingLogCaseNotesAll.vue'),
        meta: { requiresAuth: true },
    },
    /**
     * @brief 보호자 서명 리스트 연결 
     * @comment 
     * - 보호자 성명과 생년월일을 인증
     * - 서명과 관련된 전체 리스트를 여기에서 표시하고 서명 또는 확인 버튼 클릭
     * - 상세 페이지 연결되어 서명 또는 기타 정보를 확인할 수 있는 화면
     * - v-stepper로 단계별 연결이 되도록 되어 있다.
     * @see TodoFunc
     *  @component combine non contact signature - mobile common view
     *  @route - mobile common view
     * 
     * 1) m/emp/contract : 비대면 근로계약 웹뷰 서명
     * 2) 
     */
    {
        path: '/usign',
        name: 'AgreementFromGuardians',
        component: () =>
            import ('../views/guardian/GetGuardiansAgreements.vue')
    },
    // @Desc : non contact sign for guardian and employees
    {
        path: '/m/emp/contract',
        name: 'NoAuth',
        component: () =>
            import('../views/webview/UntactEmpContract.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/print/employees',
        name: 'EmployeeContract',
        component: () => 
            import ('../views/print/EmployeeContract.vue'),
        meta: { requiresAuth: true },
    },
    // 임직원 급여명세서 일괄 출력하기
    {
        path: '/print/paper/payslips',
        name: 'PaperofEmployeePayslip',
        component: () =>
            import ('../views/print/PaperofEmployeePayslip.vue'),
        meta: { requiresAuth: true },
    },
    // 수급자 급여일정계획표 일괄 출력하기
    {
        path: '/print/paper/recipient-service-plan',
        name: 'PaperofRecipientServicePlan',
        component: () =>
            import ('../views/print/PaperofRecipientServicePlan.vue'),
        meta: { requiresAuth: true },
    },
    // 희망이음 동기화 작업 관련 결과 보고서
    {
        path: '/report/syncwork',
        name: 'HopeSyncResultReport',
        component: () => 
            import('../views/financial/statement/SyncHopeResultReport.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/edit/plan',
        name: 'EditServicePlan',
        component: () =>
            import ('../views/recipient/work/EditServicePlan.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/billing/error',
        name: 'BillingErrorList',
        component: () =>
            import ('../views/recipient/work/BillingErrorList.vue'),
        meta: { requiresAuth: true }
    },
    {
        //RFID태그 에러내역 화면
        path: '/rfid/error/tag',
        name: 'RFIDerrorTag',
        component: () =>
            import ('../views/recipient/work/RFIDerrorTag.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/provide/plan/new',
        name: 'NewPageCalendar',
        component: () =>
            import ('../views/recipient/work/NewPageCalendar.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/daily/work/new',
        name: 'NewPageDailyCalendar',
        component: () =>
            import ('../views/recipient/work/NewPageDailyCalendar.vue'),
        meta: { requiresAuth: true }
    },
    {
        //일정 불일치 기록지 관리 내용보기(새페이지)
        path: '/service/match/preview',
        name: 'NotMatchPreview',
        component: () =>
            import ('../views/recipient/work/NotMatchPreview.vue'),
        meta: { requiresAuth: true }
    },
    // @Page 수급관련 페이지 개별 표시 필요(as full screen)
    {
        path: '/full/receive/contract/basics',
        name: 'ReceiveContractFullScreen',
        component: () =>
            import ('../views/recipient/contract/ReceiveContract.vue'),
        meta: { requiresAuth: true }
    },
    // @Page 계약만료 또는 계약취소에서 재계약(as full screen)
    {
        path: '/full/renew/contract/again',
        name: 'RenewContractFullScreen',
        component: () =>
            import ('../views/recipient/contract/RenewContract.vue'),
        meta: { requiresAuth: true }
    },
    // @Page 급여비용변경(수가금액변동)에 따른 재계약(as full screen)
    {
        path: '/full/renew/contract/rate',
        name: 'RenewRateCostFullScreen',
        component: () =>
            import ('../views/recipient/contract/RenewRateContract.vue'),
        meta: { requiresAuth: true }
    },
    {
        //수급계약 프린트
        path: '/full/contract/preview',
        name: 'ReceiverContract',
        component: () =>
            import ('../views/recipient/contract/ContractInfo.vue'),
        meta: { requiresAuth: true }
    },
    {
        //갱신계약 프린트
        path: '/full/contract/preview/rate',
        name: 'RenewRateContract',
        component: () =>
            import ('../views/recipient/contract/RenewRateContractInfo.vue'),
        meta: { requiresAuth: true }
    },
    // @page 수급계약 본인부담금률 페이지 새창
    {
        path: '/recipient/edit/personal/charge',
        name: 'EditRecipientPersonalCharge',
        component: () =>
            import ('../components/recipients/updateInfo/PersonalCharge.vue'),
        meta: { requiresAuth: true }
    },
    // @Page 신규 프로세스 적용 수급계약 페이지 -------------------------------
    {
        path: '/new/contract', //신규
        name: 'NewContractForm',
        component: () =>
            import ('../views/recipient/contract/NewContractForm.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/rate/contract', //갱신
        name: 'RateContractForm',
        component: () =>
            import ('../views/recipient/contract/RateContractForm.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/renew/contract', //재계약
        name: 'RenewContractForm',
        component: () =>
            import ('../views/recipient/contract/RenewContractForm.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/provisionalContract', //추가정보(새창)
        name: 'ProvisionalContract',
        component: () =>
            import ('../views/recipient/contract/ProvisionalContract.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/copays/deposit/all', //입금내역전체보기(새창)
        name: 'AllDeposit',
        component: () =>
            import ('../views/recipient/work/RecipientDepositList.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/recipient/copays/list/care', //방문요양 (새창)
        name: 'CopaysCareList',
        component: () =>
            import ('../views/recipient/work/CopaysCareIndex.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/recipient/copays/list/bath',//방문목욕 (새창)
        name: 'CopaysBathList',
        component: () =>
            import ('../views/recipient/work/CopaysBathIndex.vue'),
        meta: { requiresAuth: true }
    },
    // @Page 직원페이지 ------------------------------------------------------
    // {
    //     path: '/m/employee',
    //     name: 'EmpMoVerNoAuth',
    //     component: () => 
            
    // },
    {
        path: '/employee',
        name: 'Employee',
        component: () =>
            import ('../views/main/NaviBar.vue'),
        meta: { requiresAuth: true },
        children: [
            // @PrintPage
            {
                path: 'employment',
                name: 'ProofOfEmployment',
                component: () =>
                    import ('../views/print/employee/ProofOfEmployment.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'service/plan/print',
                name: 'StaffServicePlan',
                component: () =>
                    import ('../views/print/employee/ServicePlan.vue'),
                meta: { requiresAuth: true }
            },
            { // 종사자급여제공일정 빠른조회 서비스 상세보기
                path: 'schedule/service',
                name: 'StaffScheduleCalendar',
                component: () =>
                    import ('../views/employee/status/StaffScheduleCalendar.vue'),
                meta: { requiresAuth: true }
            },
            { // 종사자근태관리 빠른조회 서비스 상세보기
                path: 'schedule/commute',
                name: 'StaffCommuteCalendar',
                component: () =>
                    import ('../views/employee/status/StaffCommuteCalendar.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'loss/report',
                name: 'LossReport',
                component: () =>
                    import ('../views/print/employee/LossReport.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'acquisition/report',
                name: 'AcquisitionReport',
                component: () =>
                    import ('../views/print/employee/AcquisitionReport.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'id/print',
                name: 'EmployeeId',
                component: () =>
                    import ('../views/print/employee/EmployeeId.vue'),
                meta: { requiresAuth: true }
            },
            // @NotPrintPage
            {
                path: 'dashboard',
                name: 'EmployeeDashboard',
                component: () =>
                    import ('../views/employee/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status',
                name: 'EmployeeStatus',
                component: () =>
                    import ('../views/employee/EmployeeStatus.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'employeeInfo',
                name: 'EmployeeInfo',
                component: () =>
                    import ('../views/employee/EmployeeInfo.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'employeeForm',
                name: 'EmployeeForm',
                component: () =>
                    import ('../views/employee/EmployeeForm.vue'),
                meta: { requiresAuth: true }
            },
            // 임직원 상담일지 목록
            {
                path: 'counsels',
                name: 'EmployeeCounselLogIndex',
                component: () =>
                    import ('../views/employee/EmployeeCounselLogIndex.vue'),
                meta: { requiresAuth: true }
            },
            // 임직원 상담일지 작성/수정
            {
                path: 'counsel/log',
                name: 'WriteEmployeeCounselLog',
                component: () =>
                    import ('../views/employee/WriteEmployeeCounselLog.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'employer/contract',
                name: 'EmployerContract',
                component: () =>
                    import ('../views/employee/contract/EmployerContract.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'employer/done',
                name: 'EmployerDone',
                component: () =>
                    import ('../views/employee/contract/EmployerDone.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'contract/update',
                name: 'EmployeeContractConfirm',
                component: () =>
                    import ('../views/employee/contract/ConfirmContract.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'contract/list',
                name: 'EmployeeContractList',
                component: () =>
                    import('../views/employee/contract/IndexV2.vue'),
                    //import ('../views/employee/contract/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'contract/detail',
                name: 'EmployeeContractDetail',
                component: () =>
                    import ('../views/employee/contract/ContractDetail.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'employer/renew',
                name: 'EmployerRenewContract',
                component: () =>
                    import ('../views/employee/contract/RenewContract.vue'),
                meta: { requiresAuth: true }
            },
            { // 배상책임 및 치매이수 관련 설정
                path: 'status/adding/regist',
                name: 'StatusEmploymentRegist',
                component: () =>
                    import ('../views/employee/StatusEmploymentRegist.vue'),
                meta: { requiresAuth: true }
            },
            { // 근태관리설정
                path: 'status/commute/regist',
                name: 'EmployeesCommuteRegist',
                component: () =>
                    import ('../views/employee/EmployeesCommuteRegist.vue'),
                meta: { requiresAuth: true }
            },
            // @Description: 시급제(단시간근로자) 급여 일괄수정
            {
                path: 'batch/change/wage',
                name: 'BatchChangeWages',
                component: () =>
                    import ('../views/employee/BatchChangeWages.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'payinfo/card',
                name: 'EmployeePaySlip',
                component: () =>
                    import ('../views/employee/EmployeePaySlipCard.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'payinfo/list',
                name: 'EmployeePaySlips',
                component: () =>
                    import ('../views/employee/EmployeePaySlipIndex.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'payroll/close',
                name: 'CloseEmployeePayRoll',
                component: () =>
                    import ('../views/employee/EmployeePayRollClosing.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'payroll/card',
                name: 'EmployeePayRoll',
                component: () =>
                    import ('../views/employee/EmployeePayRollCard.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'payroll/list',
                name: 'EmployeesPayrolls',
                component: () =>
                    import ('../views/employee/EmployeePayRollIndex.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'social/insurance',
                name: 'SocialInsurance',
                component: () =>
                    import ('../views/employee/SocialInsurance.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'pay/change',
                name: 'PayMonthlyChange',
                component: () =>
                    import ('../views/employee/PayMonthlyChange.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'retire/year',
                name: 'EmployeeRetireYearFund',
                component: () =>
                    import ('../views/employee/EmployeeRetireYearFund.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'retire/month',
                name: 'EmployeeRetireMonthFund',
                component: () =>
                    import ('../views/employee/EmployeeRetireMonthFund.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'schedule/list',
                name: 'EmployeeScheduleList',
                component: () =>
                    import ('../views/employee/EmployeeScheduleList.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'holiday/provide',
                name: 'EmployeeHolidayProvide',
                component: () =>
                    import ('../views/employee/EmployeeHolidayProvide.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'holiday/usage',
                name: 'EmployeeHolidayUsage',
                component: () =>
                    import ('../views/employee/EmployeeHolidayUsage.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'promote/first',
                name: 'PromoteAnnualFirst',
                component: () =>
                    import ('../views/employee/PromoteAnnualFirst.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'promote/second',
                name: 'PromoteAnnualSecond',
                component: () =>
                    import ('../views/employee/PromoteAnnualSecond.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'promote/result',
                name: 'PromoteAnnualResult',
                component: () =>
                    import ('../views/employee/PromoteAnnualResult.vue'),
                meta: { requiresAuth: true }
            },
            { // not year all by once
                path: 'bind/finsurance',
                name: 'BindFourInsurances',
                component: () =>
                    import ('../views/employee/status/BindFourInsurances.vue'),
                meta: { requiresAuth: true }
            },
            { // not year all by once
                path: 'bind/cinsurance',
                name: 'BindRegChangeSalary',
                component: () =>
                    import ('../views/employee/status/BindRegChangeSalary.vue'),
                meta: { requiresAuth: true }
            },
            // years
            {
                path: 'bind/checkup',
                name: 'BindCheckupHealth',
                component: () =>
                    import ('../views/employee/status/BindCheckupHealth.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'necessary/doc',
                name: 'NecessaryDocs',
                component: () =>
                    import ('../views/employee/status/NecessaryDocsList.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'necessary/crime',
                name: 'NecessaryCrime',
                component: () =>
                    import ('../views/employee/status/NecessaryCrimeList.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'all/doc',
                name: 'EmployeeDocs',
                component: () =>
                    import ('../views/employee/EmployeeDocs.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'bind/hrs',
                name: 'BindHumanResource',
                component: () =>
                    import ('../views/employee/status/BindHumanResource.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'hrs/card',
                name: 'HumanResourceCard',
                component: () =>
                    import ('../views/employee/HumanResourceCard.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'bind/overthirty',
                name: 'BindNoServiceOverThirty',
                component: () =>
                    import ('../views/employee/status/BindNoServiceOverThirty.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'bind/workingtimes',
                name: 'BindMonthlyWorkingTime',
                component: () =>
                    import ('../views/employee/status/BindMonthlyWorkingTime.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'bind/longperiod',
                name: 'LongPeriodWorkingStaffs',
                component: () =>
                    import ('../views/employee/status/LongPeriodWorkingStaffs.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'print/payslip',
                name: 'PrintPayslip',
                component: () =>
                    import ('../views/employee/print/Payslip.vue'),
                meta: { requiresAuth: true },
            },
            // electronic document - report of attendance for employees
            {
                path: 'report/resign',
                name: 'ResignReport',
                component: () =>
                    import ('../views/authorization/resign/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'report/attendance',
                name: 'ResultofAttendance',
                component: () =>
                    import ('../views/authorization/attendance/Index.vue'),
                meta: { requiresAuth: true }
            },
        ]
    },
    /**
     * @page 직원근로계약 페이지 <근로자 계약하기>
     * @brief 임직원 관리 관련 새창에서 편집하는 화면 보기 
     * @comment 
     * 아래의 페이지를 따로 구분한 이유는 근로자가 최초 프로그램에 접속할 때 
     * 서비스 가입 및 근로계약이 되어 있지 않음으로 프로그램을 사용할 수 없는 상태이다. 
     * 따라서 근로계약을 체결해야 접근권한이 생기는 원래의 취지에 따라 근로계약서를 
     * 별도로 보여주는 것을 기본 원칙으로 하기 위해 페이지 구분
     * 
     * TODO: 근로계약 체결 완료 버튼과 개인정보보호법 관련 동의 문서도 보여주며 해당 페이지에서 받도록 한다. 
    */
    {
        path: '/employment',
        name: 'Employment',
        component: () =>
            import ('../views/employee/contract/ContractFinish.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/employment/done',
        name: 'EmploymentContractDone',
        component: () =>
            import ('../views/employee/contract/ContractDone.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/payslip',
        name: 'EmployeePayslipDefaultCard',
        component: () =>
            import ('../components/employees/DefaultPayslipCardV2.vue'),
        meta: { requiresAuth: true }
    },
    { // 종사자급여제공일정 빠른조회 서비스 상세보기
        path: '/quick/schedule/calendar',
        name: 'StaffQuickScheduleCalendar',
        component: () =>
            import ('../views/employee/status/StaffScheduleCalendar.vue'),
        meta: { requiresAuth: true }
    },
    { // 종사자근태관리 빠른조회 서비스 상세보기
        path: '/quick/schedule/commute',
        name: 'StaffQuickCommuteCalendar',
        component: () =>
            import ('../views/employee/status/StaffCommuteCalendar.vue'),
        meta: { requiresAuth: true }
    },
    // 종사자 근로계약 작성 및 수정 화면
    {
        path: '/employment/contract/edit',
        name: 'EmploymentContractEdit',
        component: () =>
            import ('../views/employee/contract/EmployerContract.vue'),
        meta: { requiresAuth: true },
    },
    // @page 종사자 정보수정 - 25.04.27
    {
        path: '/employee/edit/personal',
        name: 'BlankEmployeesForm',
        component: () =>
            import ('../views/employee/EmployeeForm.vue'),
        meta: { requiresAuth: true }
    },
    // @Page 타임라인
    {
        path: '/timeline',
        name: 'Timeline',
        component: () =>
            import ('../views/main/NaviBar.vue'),
        meta: { requiresAuth: true },
        children: [
            // @PrintPage

            // @NotPrintPage
            {
                path: 'sheet',
                name: 'MainTimelineSheet',
                component: () =>
                    import ('../views/main/Timeline.vue'),
                meta: { requiresAuth: true }
            }
        ]
    },
    // @Page 캘린더
    {
        path: '/calendar',
        name: 'Calendar',
        component: () =>
            import ('../views/main/NaviBar.vue'),
        meta: { requiresAuth: true },
        children: [
            // @PrintPage

            // @NotPrintPage
            {
                path: 'sheet',
                name: 'MainMonthSheet',
                component: () =>
                    import ('../views/main/Calendar.vue'),
                meta: { requiresAuth: true }
            }
        ]
    },
    // @Page 전자결재
    {
        path: '/authorization',
        name: 'Authorization',
        component: () =>
            import ('../views/main/NaviBar.vue'),
        meta: { requiresAuth: true },
        children: [
            // @PrintPage

            // @NotPrintPage
            {
                path: 'dashboard',
                name: 'AuthorizationDashboard',
                component: () =>
                    import ('../views/authorization/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'supplies',
                name: 'MedicalSupplies',
                component: () =>
                    import ('../views/authorization/supplies/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'supplies/approved',
                name: 'AddLogSupplies',
                component: () =>
                    import ('../views/authorization/supplies/AddLogSupplies.vue'),
                meta: { requiresAuth: true }
            },

            {
                path: 'supplies/usage',
                name: 'UsagesSupplies',
                component: () =>
                    import ('../views/authorization/supplies/UsagesSupplies.vue'),
                meta: { requiresAuth: true }
            },
            // {
            //     path: 'supplies/stock',
            //     name: 'RemainsSupplies',
            //     component: () => import('../views/authorization/supplies/RemainsSupplies.vue'),
            //     meta: { requiresAuth: true }
            // },
            // medical supplies
            {
                path: 'supplies/setting',
                name: 'MedicalSuppliesManagement',
                component: () =>
                    import ('../views/authorization/supplies/MedicalSuppliesMgmt.vue'),
                meta: { requiresAuth: true }
            },

            // report of sending sms on web
            {
                path: 'report/sendsms',
                name: 'ResultofSendSms',
                component: () =>
                    import ('../views/authorization/sms/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'report/charge',
                name: 'PaymentLog',
                component: () =>
                    import ('../views/authorization/sms/PaymentLog.vue'),
                meta: { requiresAuth: true }
            },
            // report of difficult for recipients
            // {
            //     path: 'report/difficult',
            //     name: 'ManagementDifficult',
            //     component: () => import('../views/authorization/difficult/Index.vue'),
            //     meta: { requiresAuth: true }
            // },
            // setting approval
            {
                path: 'setting/basics',
                name: 'SettingApprovalEnviroment',
                component: () =>
                    import ('../views/authorization/settings/BasicsEnviroment.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'setting/template',
                name: 'SettingApprovalTemplates',
                component: () =>
                    import ('../views/authorization/settings/ApprovalTemplates.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'setting/config/template',
                name: 'ConfigTemplate',
                component: () =>
                    import ('../views/authorization/settings/ConfigTemplate.vue'),
                meta: { requiresAuth: true }
            },
            // draft electronic document after writing
            {
                path: 'draft/document',
                name: 'DraftTemplateToWrite',
                component: () =>
                    import ('../views/authorization/WritingAndDraft.vue'),
                meta: { requiresAuth: true }
            },
            // status
            {
                path: 'status/signing',
                name: 'SigningStatus',
                component: () =>
                    import ('../views/authorization/status/StatusSigning.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status/signed',
                name: 'BeSignedStatus',
                component: () =>
                    import ('../views/authorization/status/StatusSigned.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status/return',
                name: 'ReturnSignStatus',
                component: () =>
                    import ('../views/authorization/status/ReturnStatus.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status/reference',
                name: 'ReferenceSignedDocuments',
                component: () =>
                    import ('../views/authorization/status/StatusReference.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status/read',
                name: 'ReadSignedDocuments',
                component: () =>
                    import ('../views/authorization/status/StatusReadDoc.vue'),
                meta: { requiresAuth: true }
            },
            // draft category
            {
                path: 'draft/category',
                name: 'GoDraftCategory',
                component: () =>
                    import ('../views/authorization/godraft/Index.vue'),
                meta: { requiresAuth: true }
            },
            { // 본부금 보고서
                path: 'draft/report/copay',
                name: 'SignCopayReport',
                component: () =>
                    import ('../views/authorization/godraft/CopayReport.vue'),
                // meta: { requiresAuth: true }
            },
            { // 직원급여 보고서
                path: 'draft/report/payslip',
                name: 'SignPayslipReport',
                component: () =>
                    import ('../views/authorization/godraft/PayslipReport.vue'),
                // meta: { requiresAuth: true }
            },

            // 기관운영관리 // temporary need to remove when it open account service
            // {
            //     path: 'account',
            //     name: 'BankAccountManagement',
            //     component: () => import('../views/authorization/branches/BankAccountManagement.vue'),
            //     meta: { requiresAuth: true }
            // },
            {
                path: 'info',
                name: 'BranchInfo',
                component: () =>
                    import ('../views/authorization/branches/BranchInfo.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'location',
                name: 'BranchLocation',
                component: () =>
                    import ('../views/authorization/branches/BranchLocation.vue'),
                meta: { requiresAuth: true }
            },
            // report of meeting
            {
                path: 'report/meetings',
                name: 'ReportofMeetings',
                component: () =>
                    import ('../views/authorization/meeting/Index.vue'),
                meta: { requiresAuth: true }
            },
            // report of case for recipients
            {
                path: 'report/cases',
                name: 'ReportofCases',
                component: () =>
                    import ('../views/authorization/case/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'report/steering/committee',
                name: 'ReportSteeringCommittee',
                component: () =>
                    import ('../views/authorization/steering/index.vue'),
                meta: { requiresAuth: true }
            },
            // 교육관리
            // {   교육일지
            //     path: 'report/edutask',
            //     name: 'BindTaskEducation',
            //     component: () => import('../views/employee/BindTaskEducation.vue'),
            //     meta: { requiresAuth: true }
            // },
            {
                path: 'bind/tasks',
                name: 'BindTaskEducation',
                component: () =>
                    import ('../views/authorization/binder/BindTaskEducation.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'bind/laws',
                name: 'BindLawEducation',
                component: () =>
                    import ('../views/authorization/binder/BindLawEducation.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'bind/works',
                name: 'BindWorksEducation',
                component: () =>
                    import ('../views/authorization/binder/BindWorksEducation.vue'),
                meta: { requiresAuth: true }
            },
            // insurance
            {
                path: 'insurance',
                name: 'BranchInsurance',
                component: () =>
                    import ('../views/authorization/branches/BranchInsurance.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'insurance/write',
                name: 'InsuranceForm',
                component: () =>
                    import ('../views/authorization/branches/InsuranceForm.vue'),
                meta: { requiresAuth: true }
            },
            // report for vehicle
            // {
            //     path: 'vehicle',
            //     name: 'BranchVehicle',
            //     component: () =>
            //         import ('../views/branch.setting/BranchVehicle.vue'),
            //     meta: { requiresAuth: true }
            // },
            {
                path: 'vehicle',
                name: 'BranchVehicle',
                component: () =>
                    import ('../views/authorization/branches/VehicleIndex.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'vehicle/drive',
                name: 'BranchVehicleDrive',
                component: () =>
                    import ('../views/authorization/branches/VehicleDriveIndex.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'vehicle/repair',
                name: 'BranchVehicleRepair',
                component: () =>
                    import ('../views/authorization/branches/VehicleRepairIndex.vue'),
                meta: { requiresAuth: true }
            },
            // {
            //     path: 'vehicle/log',
            //     name: 'VehicleLog',
            //     component: () =>
            //         import ('../views/branch.setting/VehicleLog.vue'),
            //     meta: { requiresAuth: true }
            // },
            // @Page Excel upload for sync from longterm-care
            {
                path: 'sync/recipients',
                name: 'SyncRecipients',
                component: () =>
                    import ('../views/branch.setting/SyncRecipients.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'sync/employees',
                name: 'SyncEmployees',
                component: () =>
                    import ('../views/branch.setting/SyncEmployees.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'sync/plans',
                name: 'SyncPlans',
                component: () =>
                    import ('../views/branch.setting/SyncPlans.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'sync/tags',
                name: 'SyncTags',
                component: () =>
                    import ('../views/branch.setting/SyncTags.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'sync/claims',
                name: 'SyncClaimDetail',
                component: () =>
                    import ('../views/branch.setting/SyncClaimDetail.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'sync/determine',
                name: 'SyncDetermineWages',
                component: () =>
                    import ('../views/branch.setting/SyncDetermineWages.vue'),
                meta: { requiresAuth: true }
            },
            // @Page Excel upload for sync from w4c.go.kr
            {
                path: 'sync/wfourc',
                name: 'SyncWFourc',
                component: () =>
                    import ('../views/branch.setting/SyncWFourc.vue'),
                meta: { requiresAuth: true }
            },
            // @Page Excel upload for contract
            {
                path: 'excel/recipient',
                name: 'ExcelContractRecipients',
                component: () =>
                    import ('../views/branch.setting/ExcelContractRecipients.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'sync/determine',
                name: 'ExcelContractEmployments',
                component: () =>
                    import ('../views/branch.setting/ExcelContractEmployments.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'report/prize',
                name: 'PrizeReport',
                component: () =>
                    import ('../views/authorization/prize/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'report/difficult',
                name: 'ManagementDifficult',
                component: () =>
                    import ('../views/authorization/difficult/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'education/report',
                name: 'EducationReport',
                component: () =>
                    import ('../views/authorization/education/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'education/legal/upload',
                name: 'LegaliyEducation',
                component: () =>
                    import ('../views/authorization/education/LegaliyEducation.vue'),
                meta: { requiresAuth: true }
            },
        ]
    },
    { // @brief : 임직원 상담일지 목록 - 새창 열기
        path: '/employee-counsel-log-index',
        name: 'EmployeeCounselLogIndexPopup',
        component: () =>
            import('../views/employee/EmployeeCounselLogIndex.vue'),
        meta: { requiresAuth: true }
    },
    { // @brief : 법정의무교육관리 매트릭스 - 새창 열기 (2026-04-24 [legal-edu-perf-name])
        path: '/legal-edu-matrix',
        name: 'LegaliyEducationMatrixPopup',
        component: () =>
            import('../views/authorization/education/LegaliyEducationMatrixPopup.vue'),
        meta: { requiresAuth: true }
    },
    { // @brief : 임직원 상담일지 - 새창 열기
        path: '/employee-counsel-log',
        name: 'WriteEmployeeCounselLogPopup',
        component: () =>
            import('../views/employee/WriteEmployeeCounselLog.vue'),
        meta: { requiresAuth: true }
    },
    { // @brief : 임직원 상담일지 출력 / PDF 내보내기 - 새창 열기
        path: '/print/staff-counsel',
        name: 'PaperofStaffCounsel',
        component: () =>
            import('../views/print/PaperofStaffCounsel.vue'),
        meta: { requiresAuth: true }
    },
    { // @brief : 이미지 뷰 - 새창 열기
        path: '/image/noext/ww',
        name: 'ImageFileNoExtNewWindow',
        component: () =>
            import('../components/commons/PreviewImageNoExt.vue'),
        meta: { requiresAuth: true}
    },
    // @Page 재무회계
    {
        path: '/financial',
        name: 'Financial',
        component: () =>
            import ('../views/main/NaviBar.vue'),
        meta: { requiresAuth: true },
        children: [
            // @PrintPage

            // @NotPrintPage
            {
                path: 'dashboard',
                name: 'FinancialDashboard',
                component: () =>
                    import ('../views/financial/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'status',
                name: 'StatusFinanical',
                component: () =>
                    import ('../views/financial/status/W4CProcess.vue')
            },
            {
                path: 'status',
                name: 'StatusTaxes',
                component: () =>
                    import ('../views/financial/status/TaxProcess.vue')
            },
            { // W4C 결의서등록 처리현황
                path: 'financial/w4c/process',
                name: 'W4CProcess',
                component: () =>
                    import ('../views/financial/status/W4CProcess.vue'),
                meta: { requiresAuth: true }
            },
            { // 세무신고 처리현황
                path: 'financial/tax/process',
                name: 'TaxProcess',
                component: () =>
                    import ('../views/financial/status/TaxProcess.vue'),
                meta: { requiresAuth: true }
            },
            { // 사회보험 처리현황
                path: 'financial/insurance/process',
                name: 'InsuranceProcess',
                component: () =>
                    import ('../views/financial/status/InsuranceProcess.vue'),
                meta: { requiresAuth: true }
            },
            { // 4대보험 취득/상실 신고
                path: 'financial/insurance',
                name: '4Insurance',
                component: () =>
                    import ('../views/financial/insurance/SocialInsurance.vue'),
                meta: { requiresAuth: true }
            },
            { // 보수변경 신고
                path: 'financial/monthly/change',
                name: 'monthlyChange',
                component: () =>
                    import ('../views/financial/insurance/PayMonthlyChange.vue'),
                meta: { requiresAuth: true }
            },
            { // 전년도이월금관리 (예산관리)
                path: 'financial/budget/prev-year-carryover',
                name: 'PrevYearCarryover',
                component: () =>
                    import ('../views/financial/budget/PrevYearCarryover.vue'),
                meta: { requiresAuth: true }
            },
            { // bank dealer
                path: 'transaction/dealer',
                name: 'TransactionalDealer',
                component: () =>
                    import ('../views/financial/statement/Dealer.vue'),
                meta: { requiresAuth: true }
            },
            { // bank account statement
                path: 'transaction/bank',
                name: 'TransactionalBank',
                component: () =>
                    //import ('../views/financial/statement/Bank.vue'),
                    // 위의 정보는 상세화면에서 사용될 수 있도록 하고, 나중에 업데이트 진행 필요 
                    import('../views/financial/statement/BankSplitViewer.vue'),
                meta: { requiresAuth: true }
            },
            { // corporation card statement
                path: 'transaction/card',
                name: 'TransactionalCard',
                component: () =>
                    import ('../views/financial/statement/CorpCard.vue'),
                meta: { requiresAuth: true }
            },
            { // general card statement
                path: 'transaction/list',
                name: 'TransactionalResolution',
                component: () =>
                    // import ('../views/financial/statement/IncomeExpenditure.vue'),
                    // 위의 정보는 상세화면에서 사용될 수 있도록 하고, 나중에 업데이트 진행 필요 
                    import ('../views/financial/statement/ResolutionBookList.vue'),
                meta: { requiresAuth: true }
            },
            { // general card statement
                path: 'transaction/deposit',
                name: 'TransactionToDeposit',
                component: () =>
                    import ('../views/financial/statement/TransactionToDeposit.vue'),
                meta: { requiresAuth: true }
            },
            { // bank deposit and withdraw transaction
                path: 'record/transaction',
                name: 'RecordTransactionList',
                component: () =>
                    import ('../views/financial/statement/RecordTransactions.vue'),
                meta: { requiresAuth: true }
            },
            { // bank deposit and withdraw transaction
                path: 'record/edition',
                name: 'Edit',
                component: () =>
                    import ('../views/financial/statement/RecordTransactions.vue'),
                meta: { requiresAuth: true }
            },
            { // 회계장부관리-결의서
                path: 'account/resolution',
                name: 'Resolution',
                component: () =>
                    import ('../views/financial/statement/Resolution.vue'),
                meta: { requiresAuth: true }
            },
            { // 회계장부관리-현금출납부
                path: 'account/book',
                name: 'AccountBook',
                component: () =>
                    import ('../views/financial/statement/AccountBook.vue'),
                meta: { requiresAuth: true }
            },
            { // 회계장부관리-총계정원장
                path: 'account/ledger',
                name: 'GeneralLedger',
                component: () =>
                    import ('../views/financial/statement/GeneralLedgerList.vue'),
                meta: { requiresAuth: true }
            },
            { // 세무대리계약서 관리
                path: 'statement/contract',
                name: 'ContractIndex',
                component: () =>
                    import ('../views/financial/statement/ContractIndex.vue'),
                meta: { requiresAuth: true }
            },
            // { // bank deposit and withdraw transaction
            //     path: 'record/vouchers',
            //     name: 'RecordTransactionList',
            //     component: () => import('../views/financial/statement/RecordTransactions.vue'),
            //     meta: { requiresAuth: true }
            // },

            { // 품의서
                path: 'writing/letter',
                name: 'LetterOfAgreement',
                component: () =>
                    import ('../views/financial/writing/LetterOfAgreement.vue'),
                meta: { requiresAuth: true }
            },
            { // 결의서
                path: 'writing/expenditure',
                name: 'ApprovalExpenditure',
                component: () =>
                    import ('../views/financial/writing/ApprovalExpenditure.vue'),
                meta: { requiresAuth: true }
            },
            { // 확정경비현황보기
                path: 'writing/usage',
                name: 'ConfirmUsageFinancial',
                component: () =>
                    import ('../views/financial/statement/ConfirmUsageFinancial.vue'),
                meta: { requiresAuth: true }
            },
            { // 예산
                path: 'writing/budget',
                name: 'BudgetTemplate',
                component: () =>
                    import ('../views/financial/writing/BudgetTemplate.vue'),
                meta: { requiresAuth: true }
            },
            { // 운영회의록
                path: 'writing/extrabudget',
                name: 'ExtraBudgetTemplate',
                component: () =>
                    import ('../views/financial/writing/ExtraBudgetTemplate.vue'),
                meta: { requiresAuth: true }
            },
            { // 운영회의록
                path: 'writing/closing',
                name: 'ClosingStatementTemplate',
                component: () =>
                    import ('../views/financial/writing/ClosingStatementTemplate.vue'),
                meta: { requiresAuth: true }
            },
            { // 운영회의록
                path: 'writing/takeminutes',
                name: 'CommiteeTakeMinutes',
                component: () =>
                    import ('../views/financial/writing/CommiteeTakeMinutes.vue'),
                meta: { requiresAuth: true }
            },
            // @Page Account and Tax
            // { // 계좌관리
            //     path: 'account/bank',
            //     name: 'BankAccountManagement',
            //     component: () => import('../views/financial/setting/BankAccountManagement.vue'),
            //     meta: { requiresAuth: true }
            // },
            { // 카드관리
                path: 'account/card',
                name: 'CorpCardManagement',
                component: () =>
                    import ('../views/financial/setting/CorpCardMgmt.vue'),
                meta: { requiresAuth: true }
            },
            { // 경비규정관리
                path: 'account/rule',
                name: 'AccountingRuleManagement',
                component: () =>
                    import ('../views/financial/setting/AccountingRuleMgmt.vue'),
                meta: { requiresAuth: true }
            },
            { // 사업등록관리
                path: 'account/project',
                name: 'AccountingProjectManagement',
                component: () =>
                    import ('../views/financial/setting/AccountingProjectMgmt.vue'),
                meta: { requiresAuth: true }
            },
            { // 계정과목관리
                path: 'account/subject',
                name: 'AccountingSubjectManagement',
                component: () =>
                    import ('../views/financial/setting/AccountingSubjectMgmt.vue'),
                meta: { requiresAuth: true }
            },
            { // 비용항목관리
                path: 'account/brief',
                name: 'AccountingBriefManagement',
                component: () =>
                    import ('../views/financial/setting/AccountingBriefMgmt.vue'),
                meta: { requiresAuth: true }
            },
        ]
    },
    /**
     * @date 26.01.10
     * @author atacit
     * @comment 멀티 싱크를 위한 페이지 로딩 필요, 동기화 실시간 상태 표시하는 모달
     */
    {
        path: '/sync/progress',
        name: 'blankSyncingProgress',
        component: () =>
            import ('../views/main/SyncingProgress.vue'),
        meta: { requiresAuth: true }
    },
    /**
     * @comment 
     * Related to financial with tax, new blank to open new a Browser.
     * 25.10.27 작성
     */
    {
        path: '/financial/resolution/ledges',
        name: 'ResolutionLedgerDetail',
        component: () =>
            import ('../views/financial/statement/ResolutionLedgers.vue'),
        meta: { requiresAuth: true }
    },
    /**
     * @comment 
     * Related to financial with bank transaction, new blank to open new a Browser.
     * 25.12.20 작성
     */
    {
        path: '/financial/bank/transaction/detail',
        name: 'TransactionalBankDetail',
        component: () =>
            import ('../views/financial/statement/BankAccountDetail.vue'),
        meta: { requiresAuth: true }
    },
    /* 
     * // @Description 
     * Related to service contract pages
     * no need to side navigation because of not one who has an authority
     * a user who has no authority to access have not shown the service page.
     */
    {
        path: '/service/contract',
        name: 'ServiceContract',
        component: () =>
            import ('../views/services/ContractRegister.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/service/contract/done',
        name: 'CompleteContract',
        component: () =>
            import ('../views/services/ContractComplete.vue'),
        meta: { requiresAuth: false }
    },
    /* 
     * // @Description
     * Related to my info page 
     * Need to separate main root routing path
     */
    {
        path: '/',
        name: 'MyAccount',
        component: () =>
            import ('../views/main/NaviBar.vue'),
        meta: { requiresAuth: true },
        children: [
            // @no-print
            {
                path: 'info',
                name: 'MyDefaultInfo',
                component: () =>
                    import ('../views/my.info/Index.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'my/employments',
                name: 'MyEmployments',
                component: () =>
                    import ('../views/my.info/Employments.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'my/payslips',
                name: 'MyPayslips',
                component: () =>
                    import ('../views/my.info/Payslips.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'my/ecards',
                name: 'MyEmployeeCards',
                component: () =>
                    import ('../views/my.info/MyEmployeeCards.vue'),
                meta: { requiresAuth: true }
            },
            {
                path: 'my/difficulties',
                name: 'MyDifficulties',
                component: () =>
                    import ('../views/my.info/MyDifficulties.vue'),
            },
            {
                path: 'my/files',
                name: 'MyFiles',
                component: () =>
                    import ('../views/my.info/MyFiles.vue'),
            },

        ]
    },
    /** 
     * @Description full screen page with momsby
     **/
    {
        path: '/account/withdrawal',
        name: 'AccountWithdrawal',
        component: () => import ('../views/my.info/AccountWithdrawal.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/copay/cms',
        name: 'CopayCMS',
        component: () => import ('../views/recipient/work/CopayCMS.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/copay/cms/application',
        name: 'copayCmsForm',
        component: () =>
            import ('../views/print/recipient/ApplicationCmsForm.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/docs/necessary',
        name: 'NecessaryDocsList',
        component: () =>
            import ('../views/recipient/workbooks/NecessaryDocsList.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/sync/recipients',
        name: 'NewSyncRecipients',
        component: () =>
            import ('../views/branch.setting/SyncRecipients.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/common/history/memo',
        name: 'MemoFullHistories',
        component: () =>
            import ('../views/common/MemoHistory.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/momsby/cms/application',
        name: 'ApplicationCmsForm',
        component: () =>
            import ('../views/print/momsby/ApplicationCmsForm.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/momsby/cms/description',
        name: 'CmsDescriptionPage',
        component: () =>
            import ('../views/print/momsby/CmsDescription.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/momsby/publish/charge',
        name: 'MomsbyPublishCharge',
        component: () =>
            import ('../views/print/momsby/MomsbyPublishCharge.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/momsby/publish/receipt',
        name: 'MomsbyPublishReceipt',
        component: () =>
            import ('../views/print/momsby/MomsbyPublishReceipt.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/momsby/receipt/cash',
        name: 'MomsbyCashReceipt',
        component: () =>
            import ('../views/print/momsby/MomsbyHometaxCashReceipt.vue'),
        meta: { requiresAuth: true }
    },
    // address will be shown
    // @Description 종사자찾기 테스트 지도
    {
        path: '/search/staff/map',
        name: 'SearchStaffMap',
        component: () =>
            import ('../views/common/SearchStaffMap.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/my/location/map',
        name: 'MyLocationAddress',
        component: () =>
            import ('../views/my.info/MyLocation.vue'),
    },
    {
        path: '/login',
        name: 'Login',
        component: () =>
            import ('../views/accounts/Login.vue')
    },
    {
        path: '/login/qr',
        name: 'Qrlogin',
        component: () =>
            import ('../views/accounts/Qrlogin.vue')
    },
    {
        path: '/reset/mobile',
        name: 'ResetMobile',
        component: () =>
            import ('../views/accounts/ResetMobile.vue')
    },
    {
        path: '/reset/password',
        name: 'ResetPassword',
        component: () =>
            import ('../views/accounts/ResetPassword.vue')
    },
    {
        path: '/joinus',
        name: 'Joinus',
        component: () =>
            import ('../views/accounts/Joinus.vue')
    },
    {
        path: '/service/policy',
        name: 'Policy',
        component: () =>
            import ('../views/services/ServicePolicy.vue')
    },
    {
        path: '/service/personal',
        name: 'Personal',
        component: () =>
            import ('../views/services/PersonalProcessPolicy.vue')
    },
    {
        path: '/service/location',
        name: 'Location',
        components: () =>
            import ('../views/services/LocationPolicy.vue')
    },
    {
        path: '/logout',
        name: 'Logout',
        component: {
            template: `
                <div>
                    <p></p>
                </div>`,
            mounted() {
                this.logout()
            },
            methods: {
                logout() {
                    this.$store.dispatch('LOGOUT')
                }
            },
        }
    },
    // @Description sms 발송 template routing 생성
    // report of sending sms on web
    {
        path: '/card/employeeInfo',
        name: 'EmployeeInfoCard',
        component: () =>
            import ('../views/employee/EmployeeInfo.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/map/employer/contract',
        name: 'mapEmployerContract',
        component: () =>
            import ('../views/employee/contract/EmployerContract.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/full/report/sendsms',
        name: 'ResultofSendSmsonFull',
        component: () =>
            import ('../views/authorization/sms/Index.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/full/branch/account',
        name: 'BranchAccountFull',
        component: () =>
            import ('../views/authorization/branches/BankAccountManagement.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/full/charge/sms',
        name: 'PersonalChargeSMS',
        component: () =>
            import ('../views/common/PersonalChargeSMS.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/full/sms',
        name: 'SendSMS',
        component: () =>
            import ('../views/common/SendSMS.vue'),
        meta: { requiresAuth: true }
    },
    // @Description 재무회계 
    { // Show the a bank transaction list on disbursement docs
        path: '/financial/transaction/bank/new',
        name: 'BlankTransactionBanks',
        component: () =>
            import ('../views/financial/statement/Bank.vue'),
        meta: { requiresAuth: true }
    },
    { // show the deposit list to make deposit list on banks
        path: '/financial/deposit/list/bank',
        name: 'DepositToPersonalCharges',
        component: () =>
            import ('../views/financial/statement/DepositToPersonalCharges.vue'),
        meta: { requiresAuth: true }
    },
    { // show the deposit list to make auto deposit list on disbursement docs.
        path: '/financial/deposit/list/dbm',
        name: 'DisbursementToPersonalCharges',
        component: () =>
            import ('../views/financial/statement/DisbursementToPersonalCharges.vue'),
        meta: { requiresAuth: true }
    },
    { // show the withdraw list to make expenditure docs as payroll
        path: '/financial/payroll/list',
        name: 'PayrollToExpenditureResolution',
        component: () =>
            import ('../views/financial/statement/PayrollToDisbursements.vue'),
        meta: { requiresAuth: true }
    },
    // @Description Error Report for the sync
    {
        path: '/sync/schedule/error',
        name: 'ServiceSyncError',
        component: () =>
            import ('@/components/commons/ServiceSyncErrorList.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/sync/rfid/error/recipient',
        name: 'SyncRFIDRecipientError',
        component: () =>
            import ('../views/recipient/work/RecipientErrorRFID.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/sync/rfid/error/staff',
        name: 'SyncRFIDStaffError',
        component: () =>
            import ('../views/recipient/work/StaffErrorRFID.vue'),
        meta: { requiresAuth: true }
    },
    // @Description 관련문서 미리보기
    {
        path: '/rel/document',
        name: 'RelDocPreview',
        component: () =>
            import ('../views/authorization/RelDocPreview.vue'),
        meta: { requiresAuth: true }
    },
    // @Description 급여정보 캘린더 신규화면
    // ServiceCalendar => ServiceScheduleCalendar 로 변경
    {
        path: '/service/calendar',
        name: 'ServiceCalendar',
        component: () =>
            import ('../views/common/ServiceScheduleCalendar.vue'),
        meta: { requiresAuth: true }
    },
    // @Description 급여정보 캘린더 리스트추가된 화면
    {
        path: '/service/calendar/list',
        name: 'ServiceCalendarList',
        component: () =>
            import ('../views/common/ServiceScheduleCalendarList.vue'),
        meta: { requiresAuth: true }
    },
    // @Description blogs
    {
        path: '/blogs',
        name: 'MomsbyBlogs',
        component: () =>
            import ('../views/main/Blogs.vue'),
        meta: { requiresAuth: true },
    },
    // Editor for SNS and others
    {
        path: '/blogs/edit',
        name: 'MomsbyBlogEdit',
        component: () =>
            import ('../views/main/BlogsEdit.vue'),
        meta: { requiresAuth: true }
    },
    // @Description a post blog on new window
    {
        path: '/blogs/post',
        name: 'MomsbyPostedBlog',
        component: () =>
            import ('../components/commons/BlogContent.vue'),
        meta: { requiresAuth: true }
    },
    // @first
    {
        path: '/before/go',
        name: 'BeforeSetPage',
        component: () =>
            import ('../views/BeforeSetPage.vue'),
        meta: { requiresAuth: true }
    },
    // @my page not as employee
    {
        path: '/my',
        name: 'MyPage',
        component: () =>
            import ('../views/my.info/Index.vue'),
        meta: { requiresAuth: true }
    },
    // @404 : error - page not found
    {
        path: "*",
        name: "PageNotFound",
        component: () =>
            import ("../views/PageNotFound.vue")
    },
    // @link page
    {
        path: '/upay',
        name: 'MomsbyChargeLink',
        component: () => import ('../views/link/MomsbyCharge.vue')
    },
    // 일정 PDF 링크발송 — 수신측 비인증 PDF 뷰어 (Stage 6)
    // 2026-04-30 path 변경: /doc/view → /link/view (단축링크 redirect 타깃 정렬)
    {
        path: '/link/view',
        name: 'LinkDocViewer',
        component: () => import ('../views/link/LinkDocViewer.vue'),
        meta: { requiresAuth: false }
    },
    // 일정 PDF 링크발송 — 발신측 발송 화면 (Stage 7, 새창)
    {
        path: '/common/personal-schedule-push',
        name: 'PersonalSchedulePush',
        component: () => import ('../views/common/PersonalSchedulePush.vue'),
        meta: { requiresAuth: true }
    }
]

const router = new Router({
    mode: 'history',
    routes: routing,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        else if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth'
            };
        }
        return { x: 0, y: 0 }
    },
})

function decodeBeIssuedToken(token) {
    let release = token.split('.')
    return JSON.parse(atob(release[1]))
}

function pageStatus(path) {
    if (path.includes('/branch')) {
        store.commit('PAGE_STATUS', 'BranchDashboard')
    } else if (path.includes('/financial')) {
        store.commit('PAGE_STATUS', 'FinancialDashboard')
    } else if (path.includes('/authorization')) {
        store.commit('PAGE_STATUS', 'AuthorizationDashboard')
    } else if (path.includes('/timeline')) {
        store.commit('PAGE_STATUS', 'MainTimelineSheet')
    } else if (path.includes('/calendar')) {
        store.commit('PAGE_STATUS', 'MainMonthSheet')
    } else if (path.includes('/senior')) {
        store.commit('PAGE_STATUS', 'SeniorDashboard')
    } else if (path.includes('/recipient')) {
        store.commit('PAGE_STATUS', 'RecipientDashboard')
    } else if (path.includes('/employee')) {
        store.commit('PAGE_STATUS', 'EmployeeDashboard')
    }
}

// TODO: 라우터에서 토큰 및 권한체크
router.beforeEach(async(to, from, next) => {
    let info = null
    let atk = localStorage.getItem('accessToken')
    let rtk = localStorage.getItem('refreshToken')
    
    if (to.matched.some(record => record.meta.requiresAuth)) { //토큰이 필요한 페이지
        // @Description: 로그인 체크이후, 서비스 가입기관과 근로계약을 점검하여 
        // TODO: 서비스 가입이 되어 있지 않다면, 메인홈페이지로 리다이렉션이 필요한 로직 추가 필요
        if (!atk && !rtk) { //토큰 없으면 로그인페이지로
            store.commit('OPEN_SYSTEM_BAR', {
                message: '사용자 로그인정보가 없습니다. 다시 로그인 해주세요.',
                color: 'warning'
            })
            next({ name: 'Login' })
        } else if (atk && rtk) {
            // release token from encode issued token info
            let releaseToken = decodeBeIssuedToken(atk)
                // set login info after refresh page from f5 or others
            store.commit('SET_REFRESH_INFO', {
                    uuid: releaseToken.sub,
                    luidx: Number(atob(releaseToken.umc)),
                    cbidx: Number(atob(releaseToken.cbc))
                })
                //토큰이 있으면 로그인 유저가 해당페이지에 권한이 있는지만 확인, 잘못된 토큰정보인지는 API호출시 확인함
            info = await store.dispatch('AUTHORITY_CONFIRM')
            store.dispatch('CLOSE_SYSTEM_BAR', false)


            if (to.fullPath === '/' && from.fullPath === '/') {
                // outside open
                // store.commit('MainDashboard', 'SeniorDashboard')
                next({ name: 'MainDashboard' })
            } else { 
                pageStatus(to.path)
                if(to.path.includes('/financial')) {
                    let programVersion = store.state.programVersion
                    if(programVersion === '11') {
                        store.commit('OPEN_SYSTEM_BAR', {message:'재무회계는 프로버전부터 사용가능합니다. 프로버전으로 변경요청 해주세요.', color:'warning'})
                        pageStatus(from.path)
                        // next({ path: from.fullPath})
                        next({ name: from.name})
                        return
                    }
                }
                next()
            }
        }
    } else { //토큰이 필요없는 페이지
        // store.commit('CLOSE_SYSTEM_BAR')
        // next()
        console.log(from.fullPath)
        if (from.fullPath === '/' && to.fullPath === '/login') {
            if (atk && rtk) {
                store.commit('CLOSE_SYSTEM_BAR')
                next({ name: 'MainDashboard' })
            } else {
                store.commit('CLOSE_SYSTEM_BAR')
                next()
            }
        } else {
            store.commit('CLOSE_SYSTEM_BAR')
            next()
        }

    }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js